<template>
  <div>
    <LlAppFixedToolBar>
      <WsTextButton001
        primary
        noPadding
        leadingIcon="icon-arrow-left"
        @click="$_backToPreviousPage()"
      >
        {{ $t('返回') }}
      </WsTextButton001>
    </LlAppFixedToolBar>
    <LlScrollableWrap v-model="position">
      <LlScrollableBlock v-if="isLoading.content">
        <NormalSkeleton />
      </LlScrollableBlock>
      <LlScrollableBlock
        v-else
        :isEllipsis2="false"
        :title="content ? content.name : ''"
      >
        <LlScrollableBlockContent
          bottom
          isAutoHeight
          paddingDefault
        >
          <ListCard
            white
            isTable
            bigTitle
            noPadding
            :title="$t(infoTitle)"
          >
            <ListCardItem
              v-for="(item, itemKey) in list"
              :key="itemKey"
              row
              isTable
              :type="item.type"
              :title="$t(item.title)"
              :chip="item.chip"
              :chipList="item.chipList"
              :textContent="item.textContent"
            />
          </ListCard>
          <slot name="subInfo" :content="content"/>
        </LlScrollableBlockContent>
        <LvDataTable
          v-if="!hideRelatedDataList"
          titleSize="h3"
          title="相關文件"
          label="相關文件"
          ref="LvDataTable"
          :fetchUrl="_fetchUrl"
          :setParams="$_setParams"
          :setListData="setListData"
          :columnHeader="columnHeader"
          :filterFieldTypes="filterFieldTypes"
          :scroll="position.scrollTop"
          class="mt-20"
          @click-item="$emit('click-item', $event)"
          @fetch-data="$emit('fetch-related-list', $event)"
        />
      </LlScrollableBlock>
    </LlScrollableWrap>
  </div>
</template>

<script>
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';
import H_common from '@/helpers/common';
import H_pageHelper from '@/helpers/pageHelper';

export default {
  props: {
    modelName: {
      type: String,
    },
    fieldList: {
      type: Array,
    },
    previousPagePath: {
      type: String,
    },
    hideRelatedDataList: {
      type: Boolean,
      default: false,
    },
    infoTitle: {
      type: String,
    },
    columnHeader: {
      type: Array,
    },
    setListData: {
      type: Function,
    },
    setParams: {
      type: Function,
    },
    filterFieldTypes: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: {
        content: true,
      },
      content: null,
      list: [],
      position: { scrollTop: 0, scrollLeft: 0 },
    };
  },
  computed: {
    _templateId() {
      return this.$route.params.templateId;
    },
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _query() {
      return this.$route.query;
    },
    _fetchUrl() {
      return `factory/${this._currentFactoryId}/${this.modelName}`;
    }
  },
  watch: {
    filterFieldsProps() {
      this.filterFields = this.filterFieldsProps;
    },
  },
  async mounted() {
    await this.$_init();
  },
  methods: {
    async $_init() {
      this.isLoading.content = true;
      await this.$_getContentData();
      this.isLoading.content = false;
    },
    async $_getContentData() {
      this.content = await S_base.show({
        url: `factory/${this._currentFactoryId}/${this.modelName}_template/${this._templateId}`,
      });
      this.$emit('fetch-content', this.content);
      this.list = this.$_getFieldList(this.fieldList, this.content);
    },
    $_backToPreviousPage() {
      const path = `/factory/${this._currentFactoryId}/${this.previousPagePath}`;
      const url = H_pageHelper.getBackRoute({
        query: this._query,
        defaultUrl: {
          path,
          query: this._query,
        },
      });
      this.$router.push(url);
    },
    $_getCardItemProps(content, tarTitle, tarPropType) {
      return H_common.setShowTemplateProps(content, this.fieldList, tarTitle, tarPropType);
    },
    $_setParams(filterState) {
      const params = this.setParams(filterState);
      return {
        ...params,
        [`${this.modelName}_template`]: this._templateId,
      };
    },
    $_getFieldList(fieldList, content) {
      let resultArr = [];
      for (let item of fieldList) {
        const {type, title, propTypeList} = item;
        const result = {type, title};
        propTypeList.forEach(propType => {
          result[propType] = H_common.setShowTemplateProps(content, fieldList, title, propType);
        })
        resultArr.push(result);
      }
      return resultArr.filter(result => !(result.type === 'chip-list' && !result.chipList.length));
    }
  },
};
</script>